export const myAccountKeys = {
  all: ['all', 'myAccount'] as const,
  getPointsHistory: (params: string[]) => [...myAccountKeys.all, 'getPointsHistory', ...params],
  getExpiresPointsHistory: (params: string[]) => [...myAccountKeys.all, 'getExpiresPointsHistory', ...params],
} as const
